// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "./js/" + ({"388":"result","864":"message-page","962":"home"}[chunkId] || chunkId) + "." + {"73":"f493a4a3","388":"b911b570","558":"de96b998","864":"2ea85a64","962":"98ad3d81"}[chunkId] + ".js";
};